<style lang="less">
@import './menu.less';
</style>

<template>
    <Menu ref="sideMenu" :active-name="$route.name" :open-names="['1','2']" :theme="$store.state.menuTheme" width="135" @on-select="changeMenu">
        <template v-for="item in menuList">
            <MenuItem 
                v-if="item.children.length<=1 && (!item.menuAccess || item.menuAccess.indexOf(access) != -1)" 
                :name="item.children[0].name" 
                :key="item.path" 
                style="padding-left: 15px;" 
                @click.native="handleMenuItemClick(item)">
                    <span class="promotion" v-if="item.title == '春季促销'">促销</span>
                    <!-- <Icon v-else :type="item.icon" :size="iconSize" ></Icon> -->
                    <i :class="'iconfont ' + item.icon" :style="'font-size:' + iconSize+'px'"></i>
                    <span class="layout-text" >{{ itemTitle(item) }}
                        <Badge dot :count="feeMenuBadge(item)" style="width: 100%; position: absolute; top: 3px; left: 0;"></Badge>
                        <!-- <div  v-if="item.title == '舱单发送' && currentName == 'home_index'"  class="prompt-msg"> 
                            <img src="../../images/silde-left.png">
                            <span class="prompt-msg__title" @click="goNewFeat()">
                                "舱单发送"
                            </span>
                            <b class="prompt-msg__txt">新功能上线啦,快去看看吧</b>
                       </div> -->
                       <!-- 隐藏 舱单发送 new 标签  -->
                       <!-- <div  v-if="item.title == '舱单发送'" class="shippingbill-badge"> 
                            <img src="../../images/new.png" >
                       </div> -->
                       <Badge dot v-if="item.title == '我的订单' && canEvaluate" style="width: 100%; position: absolute; top: 3px; left: 0;"></Badge>
                    </span>
                     <!-- 隐藏 我的订单 待评价 标签 显示为红点 -->
                    <!-- <span class="hasEvaluate" style="color:white" v-if="item.title == '我的订单' && canEvaluate">待评价</span> -->
                    
            </MenuItem>


            <Submenu v-if="item.children.length>1" :name="item.name" :key="item.title">
                <template slot="title">
                    <Badge dot :count="feeMenuBadge(item)" style="width: 100%;">
                        <i :class="'iconfont ' + item.icon" :style="'font-size:' + iconSize+'px'"></i>
                        <span class="layout-text">{{ itemTitle(item) }}</span>
                    </Badge>
                </template>
                <template v-for="child in item.children">
                    <MenuItem :name="child.name" :key="child.name">
                        <i :class="'iconfont ' + item.icon" :style="'font-size:' + iconSize+'px'"></i>
                        <span class="layout-text" :key="child.name">{{ child.title }}</span>
                    </MenuItem>
                </template>
            </Submenu>
        </template>
    </Menu>
</template>

<script>
import util from '@/libs/util';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
Vue.use(VueI18n);
export default {
    data() {
        return {
            openedSubmenuArr: this.$store.state.openedSubmenuArr,
            access: Cookies.get('access')
        };
    },
    name: 'sidebarMenu',
    props: {
        slotTopClass: String,
        menuList: Array,
        iconSize: {
            type: Number,
            default: 14
        }
    },
    computed: {
        tagsList() {
            return this.$store.state.tagsList;
        },
        feeMenuBadge(title) {
            return title => {
                let array = util.deepClone(this.$store.state.menuBadgeList)
                let ret = '0'
                for (let index = 0; index < array.length; index++) {
                    if(this.itemTitle(title) == array[index]) {
                        ret = ''
                        break
                    }
                }
                return ret;
            }
        },
        canEvaluate(){
            return this.$store.state.canEvaluate;
        },
        currentName(){
            return this.$store.state.currentPageName;
        }
    },
    methods: {
        handleMenuItemClick(item) {
            if (item.title === '舱单发送') {
                _hmt.push(['_trackEvent', 'PC-订单中心', 'PC-订单中心-舱单发送', `用户名:${Cookies.get('user')}`])
            }
        },
        goNewFeat(){
            this.$router.push({name:'shipping-bill'})
        },
        changeMenu(active) {
            if (active !== 'accesstest_index') {
                let keyConfig = {
                    'main-query-charge_index': '查询运价/下单',
                    'create-history-order_index': '老门点下单',
                    'coupon_index': '我的优惠券',
                    'order-booking_index': '我的订单',
                    'order-tracking_index': '运输跟踪',
                    'container-orders_index': '箱单查询',
                    'data-compare_index': '进港数据对比',
                    'fee-confirmation_index': '费用确认',
                    'account-checking_index': '	月结对账'
                }
                _hmt.push(['_trackEvent', 'PC-订单中心', 'PC-订单中心-'+keyConfig[active], `用户名:${Cookies.get('user')}`])
                util.openNewPage(this, active);
                this.$router.push({
                    name: active
                });
            }
        },
        itemTitle(item) {
            if (typeof item.title === 'object') {
                return this.$t(item.title.i18n);
            } else {
                return item.title;
            }
        }
    },
    watch: {
        $route(to) {
            localStorage.currentPageName = to.name;
        },
        //設置完openName，activeName后要重新更新dom（利用updateOpened和updateActivename）
        currentPageName() {
            this.openedSubmenuArr = this.$store.state.openedSubmenuArr;
            this.$nextTick(() => {
                this.$refs.sideMenu.updateOpened();
            });
        }
    },
    updated() {
        this.$nextTick(() => {
            // this.$refs.sideMenu.updateOpened();
        });
    }
};
</script>



// WEBPACK FOOTER //
// sidebarMenu.vue?1f443528